<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-start">
      <div>
        <Breadcrumbs
          :headline="get(selectAuditProductDetail, 'importOrderCode')"
          :link="[{ text: 'Danh sách kiểm hàng nhập', href: '/audit-product' }]"
          :chip="{
            show: true,
            color: selectAuditProductDetail.statusOrder === 'open' ? 'green' : 'red',
            textColor: 'white',
            text: selectAuditProductDetail.statusOrder === 'open' ? 'Đang mở' : 'Đã đóng'
          }"
        />
      </div>
      <SelectStatusAuditProduct :status="auditStatus" />
    </div>
    <div class="pa-4">
      <div class="mb-4">
        <h2>
          Kiểm hàng theo Đơn hàng nhập
          {{ get(selectAuditProductDetail, 'productIndustry.name') }} /
          {{ get(selectAuditProductDetail, 'producer.name') }} /
          {{ get(selectAuditProductDetail, 'productType.name') }} -
          {{ getDeliveredAt(selectAuditProductDetail.deliveredAt) }}
        </h2>
      </div>
      <div class="d-flex justify-space-between align-center pb-2">
        <h2>Nội dung</h2>
        <div hide-details>
          <div class="d-flex mb-3">
            <v-btn
              v-if="isUpdate && selectAuditProductDetail.statusOrder === 'open'"
              @click.stop="() => $refs['table-product'].updateMany()"
              class="ml-6 text-none"
              dark
              depressed
              color="#0D47A1"
            >
              <v-icon class="mr-2">mdi-pencil</v-icon>Chỉnh sửa thông tin
            </v-btn>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="ml-2" text v-on="on" icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <UploadExcel @refresh="refresh" />
            </v-menu>
          </div>
        </div>
      </div>
      <TableProductModel
        ref="table-product"
        @onSelected="isUpdate = true"
        @offSelected="isUpdate = false"
        @refresh="refresh"
      />
      <div>
        <HistoryLog v-if="selectAuditProductDetail.importDelivery" :history="history" :createdDate="createdDate" />
      </div>
      <TableScanImei ref="check-imei" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { get } from 'lodash'
import moment from 'moment'
import { formatDateDDMMYYYY, sortISOStrings } from '@/helpers/date.js'
import UploadExcel from '../../modules/detail-audit-product/UploadExcel.vue'
import SelectStatusAuditProduct from '@/components/samnec/SelectStatusAuditProduct.vue'
import HistoryLog from '@/components/samnec/HistoryLog.vue'
import TableScanImei from './scanImei/ScanImei.vue'
import TableProductModel from './TableProductModel.vue'
export default {
  components: {
    Breadcrumbs,
    UploadExcel,
    SelectStatusAuditProduct,
    HistoryLog,
    TableScanImei,
    TableProductModel
  },
  computed: mapState({
    selectAuditProductDetail(state) {
      return state['auditProducts'].item
    },
    auditStatus(state) {
      const selectAudit = state['auditProducts'].item
      return get(selectAudit, 'status')
    }
  }),
  data() {
    return {
      isUpdate: false,
      get,
      moment,
      status: 'created',
      history: [],
      createdDate: ''
    }
  },
  methods: {
    ...mapActions({
      fetchOneAuditProduct: 'auditProducts/fetchOne',
      updateAuditProduct: 'auditProducts/updateItem',
      removeAuditProduct: 'auditProducts/removeItem',
      getImportDeliveryProduct: 'auditProducts/getImportDeliveryProduct',
      countImportDeliveryProduct: 'auditProducts/countImportDeliveryProduct',
      getStats: 'auditProducts/getStats',
      getHistory: 'auditTrails/getHistory'
    }),
    async refresh() {
      await this.initData(this.$route.params.id)
      this.$refs['table-product'].initData()
    },
    async fetchHistory(id) {
      this.history = await this.getHistory({
        id,
        type: 'import-checks',
        params: { _sort: 'createdAt:DESC' }
      })
    },
    getDeliveredAt(listDeliveredAt) {
      const sortData = sortISOStrings(listDeliveredAt)
      if (!sortData || sortData.length === 0) return 'Chưa có ngày giao'
      if (sortData.length === 1) return `Ngày ${formatDateDDMMYYYY(sortData[0])}`
      return `Từ ${formatDateDDMMYYYY(sortData[0])} đến ${formatDateDDMMYYYY(sortData[sortData.length - 1])}`
    },
    async initData(id) {
      await this.fetchOneAuditProduct(id)
      await this.fetchHistory(id)
    }
  },
  watch: {
    selectAuditProductDetail: {
      handler(val) {
        if (val && val.id) {
          this.createdDate = get(val, 'createdAt', '')
        }
      },
      immediate: true
    },
    '$route.params.id': {
      async handler(val) {
        if (val) await this.initData(val)
      },
      immediate: true
    }
  }
}
</script>
